import * as React from "react";
import Typography from "../typography/index.tsx";
import { Flex, Form, Row, Select } from "antd";
import RadioButton from "../Icons/RadioButton.tsx";
import { City, shopService } from "../../services/shopService.ts";
import { SelectStyled } from "../utils/utils.tsx";

const CityDeliveryForm = ({ city, setCity, setCityRef, isActive, setActive }) => {
  const [cities, setCities] = React.useState<City[] | undefined>([]);
  const [cityLoading, setCityLoading] = React.useState<boolean>();

  React.useEffect(() => {
    setCityLoading(true);
    shopService
      .getCities({ findByString: city })
      .then(setCities)
      .finally(() => setCityLoading(false));
  }, [city]);

  // Значення селекта лишається описом, щоб не ламати вигляд і валідацію форми,
  // а GUID підіймаємо окремо -- саме він потрібен Новій Пошті.
  const onCitiesChange = (value, option) => {
    setCity(value);
    setCityRef(option?.ref ?? "");
  };

  const onCitiesSearch = (e) => {
    setCity(e);
  };

  return (
    <>
      <Typography style={{ textTransform: "uppercase" }} variant="h4">
        Доставка
      </Typography>
      <Form.Item
        name={"city"}
        initialValue={city}
        rules={[{ required: true, message: "Відсутнє місто доставки" }]}
      >
        <SelectStyled
          showSearch
          value={city}
          options={cities?.map(({ description, ref }) => ({
            value: description,
            label: description,
            ref,
          }))}
          onChange={onCitiesChange}
          onSearch={onCitiesSearch}
          loading={cityLoading}
          
        />
      </Form.Item>
      <Flex onClick={() => setActive(!isActive)} gap={"4px"}>
        <RadioButton isActive={isActive} />
        <Typography variant="uppercase">Відділення Нової Пошти</Typography>
      </Flex>
    </>
  );
};

export default CityDeliveryForm;
